import type { BookingReservationDetail } from '@/types';
import type { RescheduleBookingReservationData } from '@/types/api/mutations';
import type { RescheduleBookingReservationFormValues } from '@/types/schemas';

import { bookingTime } from '@/helpers';

export const rescheduleReservationPayload = (
  values: RescheduleBookingReservationFormValues,
  reservation: BookingReservationDetail,
): { reservation: RescheduleBookingReservationData } => ({
  reservation: {
    staff_id: Number(values.staff_id),
    location_id: Number(values.location_id),
    starts_at: `${values.date}T${bookingTime(values.starts_at)}`,
    guest_info: reservation.client ? null : values.guest_info.trim() || null,
    note: values.note.trim() || null,
    staff_comment: values.staff_comment.trim() || null,
  },
});
